export default __webpack_public_path__ + "static/media/5B4FA087-F804-41D6-AAD8-ED27B3805DC3.c7f3fdbe.jpeg";